(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sej-multi-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    root.querySelectorAll('[data-sej-multi-filter]').forEach(section => {
      if (section.dataset.sejReady) return;
      section.dataset.sejReady = 'true';
      const buttons = section.querySelectorAll('[data-sej-filter]');
      const cards = section.querySelectorAll('[data-sej-shape]');
      buttons.forEach(button => button.addEventListener('click', () => {
        const filter = button.dataset.sejFilter;
        let count = 0;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => {
          card.hidden = filter !== 'all' && card.dataset.sejShape !== filter;
          if (!card.hidden) count++;
        });
        section.querySelector('[data-sej-count]').textContent = count;
      }));
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
